import type { ActivationFlowAction, ActivationFlowModel } from './ActivationFlow.types'

export const reduceActivationSetupAction = (
  state: ActivationFlowModel,
  action: ActivationFlowAction,
): ActivationFlowModel | null => {
  switch (action.type) {
    case 'SETUP_PASSWORD_CHANGED': {
      return {
        ...state,
        setup: {
          ...state.setup,
          password: action.value,
          passwordDirty: true,
          error: '',
        },
      }
    }
    case 'SETUP_CONFIRM_PASSWORD_CHANGED': {
      return {
        ...state,
        setup: {
          ...state.setup,
          confirmPassword: action.value,
          confirmPasswordDirty: true,
          error: '',
        },
      }
    }
    case 'SETUP_PASSWORD_TOUCHED': {
      return {
        ...state,
        setup: {
          ...state.setup,
          passwordTouched: true,
        },
      }
    }
    case 'SETUP_CONFIRM_PASSWORD_TOUCHED': {
      return {
        ...state,
        setup: {
          ...state.setup,
          confirmPasswordTouched: true,
        },
      }
    }
    case 'SETUP_SUBMIT_ATTEMPTED': {
      return {
        ...state,
        status: 'setup',
        setup: {
          ...state.setup,
          formSubmitted: true,
          passwordTouched: true,
          confirmPasswordTouched: true,
          error: '',
        },
      }
    }
    case 'SETUP_REQUEST_STARTED': {
      return {
        ...state,
        status: 'setup',
        setup: {
          ...state.setup,
          submitState: 'pending',
          error: '',
        },
      }
    }
    case 'SETUP_SUCCESS': {
      return {
        ...state,
        status: 'success',
        setup: {
          ...state.setup,
          submitState: 'idle',
          error: '',
        },
      }
    }
    case 'SETUP_FAILURE': {
      return {
        ...state,
        status: 'setup',
        setup: {
          ...state.setup,
          submitState: 'idle',
          error: action.message,
        },
      }
    }
    case 'SETUP_TOKEN_EXPIRED': {
      return {
        ...state,
        status: 'expired',
        setup: {
          ...state.setup,
          submitState: 'idle',
        },
      }
    }
    case 'SETUP_TOKEN_INVALID': {
      return {
        ...state,
        status: 'invalid',
        setup: {
          ...state.setup,
          submitState: 'idle',
        },
      }
    }
    default:
      return null
  }
}
